import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import "../assets/style.scss"

type propType = {
  configValue: string
}

const LandingHeader = ({configValue}: propType) => {
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="landing-header-text-wrapper">
        <Block className="landing-header-text">
          <Element type="h1" className="header-text1">{configValue}</Element>
        </Block>
      </Block>
      <Image path={"./img/ticarikredi/ticarikredi_banner.jpg"} className="landing-header-img" />
    </Block>
  )
}

export default LandingHeader
